export const sumMinutesToHours = (hours?: number, minutes?: number) => {
  if (!minutes || !hours) {
    if (!hours && minutes) return minutes / 60
    if (hours && !minutes) return hours

    return 0
  }

  return hours + minutes / 60
}
